/**
 * Included items (accessories) at Testing and Manual listing.
 * Inbox deflection W7 (spec docs/specs_20261102_inbox_deflection.md).
 *
 * The step is required: staff tick what came with the item, or "Nothing else
 * included". Buyers asked what was in the box in about a fifth of pre-purchase
 * emails, and an unticked step left the listing silent on it.
 *
 * "Nothing else included" is a confirmation, not an accessory. It never leaves
 * the screen: `includedItemsForSubmit` drops it, so the warehouse sees an empty
 * list and the listing says "No additional accessories included", as it always
 * has for an empty list.
 */

export const NOTHING_ELSE_ID = 'none'
export const OTHER_ID = 'other'
const NOTHING_ELSE_OPTION = { id: NOTHING_ELSE_ID, label: 'Nothing else included' }

/** The options to show: the checklist's own, once each, then "Nothing else included". */
export function includedItemOptions(checklistOptions) {
  const seen = new Set()
  const options = []
  for (const option of checklistOptions || []) {
    const id = typeof option === 'string' ? option : option.id
    if (!id || seen.has(id) || id === NOTHING_ELSE_ID) continue
    seen.add(id)
    options.push({ id, label: typeof option === 'string' ? option : (option.label || id) })
  }
  return [...options, NOTHING_ELSE_OPTION]
}

/**
 * Tick or untick one option. "Nothing else included" and real items cannot be
 * ticked together: choosing one clears the other.
 */
export function toggleIncludedItem(selected, id) {
  const current = selected || []
  if (current.includes(id)) return current.filter(item => item !== id)
  if (id === NOTHING_ELSE_ID) return [NOTHING_ELSE_ID]
  return [...current.filter(item => item !== NOTHING_ELSE_ID), id]
}

/** True once staff have answered the step: at least one tick, and Other described if ticked. */
export function includedItemsAnswered(selected, otherText) {
  const current = selected || []
  if (current.length === 0) return false
  if (current.includes(OTHER_ID) && !String(otherText || '').trim()) return false
  return true
}

/** The list to send on: the ticks without "Nothing else included". */
export function includedItemsForSubmit(selected) {
  return (selected || []).filter(id => id !== NOTHING_ELSE_ID)
}
